import { all, call, put, fork, takeEvery } from 'redux-saga/effects';
import { APIClient, setAuthorization } from '../../helpers/apiClient';
import { getAccessToken } from '../../helpers/user';
import { FETCH_VIDEOS, FETCH_VIDEO_DETAIL } from './constants';
import {
  fetchVideosSuccess,
  fetchVideosFail,
  fetchVideoDetailSuccess,
  fetchVideoDetailFail,
} from './actions';

const get = new APIClient().get;

function* fetchVideos({ payload }) {
  const params = {
    page: payload.page,
    order_by: payload.order_by,
    keyword: payload.keyword,
  };

  // Clean up empty parameters
  params.order_by === '' && delete params?.order_by;
  params.keyword === '' && delete params?.keyword;

  const resetVideos = payload.resetVideos;

  try {
    setAuthorization(getAccessToken());
    const response = yield call(get, 'api/section-lectures', {
      params: params,
    });
    yield put(fetchVideosSuccess({ data: response.data, resetVideos }));
  } catch (error) {
    yield put(fetchVideosFail({ data: [], error: error.message }));
  }
}

function* fetchVideoDetail({ payload }) {
  try {
    setAuthorization(getAccessToken());
    const response = yield call(get, `api/section-lectures/${payload}`);
    yield put(fetchVideoDetailSuccess(response.data));
  } catch (error) {
    yield put(fetchVideoDetailFail({ error: error.message }));
  }
}

export function* watchFetchVideos() {
  yield takeEvery(FETCH_VIDEOS, fetchVideos);
}

export function* watchFetchVideoDetail() {
  yield takeEvery(FETCH_VIDEO_DETAIL, fetchVideoDetail);
}

function* videoSaga() {
  yield all([fork(watchFetchVideos), fork(watchFetchVideoDetail)]);
}

export default videoSaga;
